import CalendarSurfaceStore from './schema/CalendarSurfaceStore';
import { CalendarNavigationMode } from 'fabric-calendar';
import { createStore } from 'satcheljs';
import { MiniDateRangeType } from 'mini-datetime-utils/lib/MiniDateRangeType';
import { ObservableMap } from 'mobx';
import { owaDate } from 'owa-datetime/lib';

export function createEmptySurfaceStore(): CalendarSurfaceStore {
    return {
        dateRangeType: MiniDateRangeType.Agenda,
        selectedDate: owaDate(),
        todayDate: owaDate(),
        navigationMode: CalendarNavigationMode.Week,
        dateRange: null,
        isReadingPaneVisible: false,
        isComposeVisible: false,
        isQuickComposeVisible: false,
        dateToNavigate: owaDate(),
        eventsCountInfo: { range: null, eventsCountMap: new ObservableMap() },
        activeSurfaceView: null,
        showSpinner: true,
        isSurfaceReloadPending: false,
        requestId: 0,
    };
}

const surfaceStoreData: CalendarSurfaceStore = createEmptySurfaceStore();
const getSurfaceStore = createStore<CalendarSurfaceStore>('calendarSurfaceStore', surfaceStoreData);

export const calendarSurfaceStore = getSurfaceStore();

export default getSurfaceStore;
